import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('health-board', 'payment-verification');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'payment_orders',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['paymentOrderId'],
    },
    'payment_verifications',
  ],
});

export default createReqReducer(consts, true);



// WEBPACK FOOTER //
// ./src/redux/healthboard/requests/payment-verifications-req.js